<template>
  <v-dialog v-model="active" max-width="600px">
    <v-card>
      <v-card-title>{{$t('newsletter.heading')}}</v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field
            v-model="firstname"
            :label="$t('newsletter.name')"
            prepend-inner-icon="mdi-account-badge-outline"
            clearable
            outlined>
          </v-text-field>
          <v-text-field
            v-model="surname"
            :label="$t('newsletter.surname')"
            prepend-inner-icon="mdi-account-badge-outline"
            clearable
            outlined>
          </v-text-field>
          <v-text-field
            v-model="email"
            :label="$t('newsletter.email')"
            prepend-inner-icon="mdi-at"
            clearable
            required
            outlined>
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-divider class="mt-16"></v-divider>
      <v-card-actions>
        <v-btn color="darken" @click="$emit('onClose')">{{$t('newsletter.close')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success darken" @click="save()">{{$t('newsletter.save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'PlaceBetForm',
  props: ['active'],
  methods: {
    save () {
      let vm = this
      let lang = this.$root.$i18n.locale || 'de'
      let payload = {
        firstname: vm.firstname,
        email: vm.email,
        surname: vm.surname
      }
      vm.$store.dispatch(`addUser`, { lang, payload })
      vm.$emit('onSave', payload)
    }
  },
  data () {
    return {
      firstname: '',
      email: '',
      surname: ''
    }
  }
}
</script>
